import { IonHeader, IonIcon, IonPopover, useIonViewWillLeave, IonGrid, IonRow, IonCol, IonList, IonItem, IonLabel, IonNote, IonListHeader } from '@ionic/react';
import React, { Fragment, useState } from 'react';
import './FellowshipGroupSelectorHeader.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { caretDown, people, peopleOutline} from 'ionicons/icons';
import { ReactComponent as NewChatBubbleIcon } from '../../assets/images/chatbubbles-sharp-new.svg';
import IFellowshipGroups from '../../interfaces/IFellowshipGroups';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import { useHistory } from 'react-router';

interface IFellowshipGroupSelectorHeader extends IRouteInfo {
    userGroups?: IFellowshipGroups | null,
    activeGroupId?: string,
    className?: string,
    setActiveGroup: (groupId: string) => void,
    disableGroupSelector?: boolean, 
}

const FellowshipGroupSelectorHeader: React.FC<IFellowshipGroupSelectorHeader> = (props) => {
    const history = useHistory();
    const [showActiveGroupMenu, setShowActiveGroupMenu] = useState(false);
    const [activeGroupMenuEvent, setActiveGroupMenuEvent] = useState<Event | undefined>(undefined);


    useIonViewWillLeave(() => {
        setShowActiveGroupMenu(false); 
        setActiveGroupMenuEvent(undefined);
    });

    const accountHeaderMenuContent = (groups?: IFellowshipGroups | null, groupId?: string) => {
        if(groups && groupId) {
            const allGroups = Array.from(Object.values(groups));
            return ( 
                <IonList className="fellowship-group-menu-list">
                    <IonListHeader>
                    <IonLabel className="fellowship-group-menu-header">SET YOUR ACTIVE GROUP:</IonLabel>
                </IonListHeader>
                    { allGroups.map((groupInfo, index) => 
                    <IonItem 
                        className={groupId === groupInfo.group.id ? 'fellowship-group-menu-item-selected' : 'header-menu-item'}
                        key={`select-${groupInfo.group.id}`} onClick={() => props.setActiveGroup(groupInfo.group.id)}
                        lines={index + 1 < allGroups.length ? 'inset' : 'none'}
                        >
                        <IonLabel>{groupInfo.group.name}</IonLabel>
                        <IonIcon slot="start" icon={groupId === groupInfo.group.id ? people : peopleOutline}></IonIcon>
                        <IonNote slot='end'>
                            {groupInfo.hasNewPosts && <NewChatBubbleIcon className="color-tertiary fellowship-group-menu-new-posts"></NewChatBubbleIcon>}
                        </IonNote>
                    </IonItem>)}
                    {/* <IonItem 
                        className="header-menu-item" 
                        lines="none"
                        onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupCreate].path, { direction: 'forward' })}>
                        <IonLabel>Manage Your Groups</IonLabel>
                        <IonIcon slot="start" icon={peopleOutline}></IonIcon>
                    </IonItem> */}
                </IonList>);
        } else {
            return (<span></span>);
        }
    }
  
  
    return (
        <Fragment>
        <IonHeader mode='ios' className={`fellowship-group-selector-header ${props.className}`}>
            <IonGrid fixed={true} className="fellowship-header-selector-toolbar">
                <IonRow className="fellowship-header-selector-row">
                    <IonCol>
                        <div className="fellowship-group-selector" onClick={e => { 
                            if(props.activeGroupId && props.userGroups?.hasOwnProperty(props.activeGroupId) && !props.disableGroupSelector) {
                                setShowActiveGroupMenu(true); 
                                setActiveGroupMenuEvent(e.nativeEvent);
                            }
                        }}>
                            <div className="fellowship-group-selector-left"></div>
                            <div className="fellowship-group-selector-middle">
                            <IonIcon slot="start" icon={people} className="bible-version-arrow"></IonIcon>
                            {props.activeGroupId && props.userGroups?.hasOwnProperty(props.activeGroupId) ? 
                                props.userGroups[props.activeGroupId].group.name : 'You Have No Groups'
                            }
                            </div>
                            <div className="fellowship-group-selector-right">
                            { !props.disableGroupSelector && <IonIcon icon={caretDown} /> }
                            </div>
                        </div>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonHeader>
            <IonPopover
                mode="md"
                className="fellowship-group-menu-pop-up"
                dismissOnSelect={true}
                isOpen={showActiveGroupMenu}
                event={activeGroupMenuEvent}
                onDidDismiss={() => {
                    setShowActiveGroupMenu(false); 
                    setActiveGroupMenuEvent(undefined);
                }}
            > {accountHeaderMenuContent(props.userGroups, props.activeGroupId)}</IonPopover>
        </Fragment>
    );
};

export default FellowshipGroupSelectorHeader;